'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommunicationChat = function CommunicationChat(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 9h12v2H6V9zm8 5H6v-2h8v2zm4-6H6V6h12v2z' })
  );
};
CommunicationChat = (0, _pure2.default)(CommunicationChat);
CommunicationChat.displayName = 'CommunicationChat';
CommunicationChat.muiName = 'SvgIcon';

exports.default = CommunicationChat;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/svg-icons/communication/chat.js
// module id = 2768
// module chunks = 0